/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

import {IApp, IClassProvider} from '../../@interfaces/services/App';
import {IHttp} from '../../@interfaces/services/Http/IHttp';

export default abstract class AbstractProvider implements IClassProvider {
	readonly priority: number = 0;
	readonly shouldAwait: boolean = false;
	readonly holdBootUntilNotCompleted: boolean = true;

	constructor(
		readonly app: IApp
	) {
	}

	async boot(app: IApp): Promise<void> {
	}

	async loading(http: IHttp): Promise<void> {
	}

	protected getStoredService<I>(name: string): I {
		return this.app.make<I>(name) as I;
	}
}
